export default __webpack_public_path__ + "static/media/Groupe.ebf2bbe4.svg";